/**
 * @generated SignedSource<<7d761dad599ac44177e53ba2dc07cb2e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TimelineItemsViewer$data = {
  readonly login: string;
  readonly " $fragmentSpreads": FragmentRefs<"ReactionViewerUser">;
  readonly " $fragmentType": "TimelineItemsViewer";
};
export type TimelineItemsViewer$key = {
  readonly " $data"?: TimelineItemsViewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"TimelineItemsViewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TimelineItemsViewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "login",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ReactionViewerUser"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "c28c7efd45ec84c39e714edee2da32f4";

export default node;
